import React from 'react';
import { Mail, Linkedin, Github, MessageCircle } from 'lucide-react';

const Contact = ({ t }) => {
  const whatsappNumber = '5551994510711';
  const email = 'suporte.lucasgs@gmail.com';
  const linkedin = 'https://www.linkedin.com/in/lucas-gonzales/';

  const handleWhatsApp = () => {
    const message = encodeURIComponent(t.contact.subtitle);
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <h2 className="section-title-large">{t.contact.title}</h2>
        <p className="contact-subtitle">{t.contact.subtitle}</p>
        
        <div className="contact-cta">
          <button className="btn-primary btn-large" onClick={handleWhatsApp}>
            <MessageCircle size={24} />
            {t.contact.cta}
          </button>
        </div>
        
        <div className="contact-links">
          <a 
            href={`mailto:${email}`} 
            className="contact-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Mail size={20} />
            {t.contact.email}
          </a>
          
          <a 
            href={linkedin} 
            className="contact-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Linkedin size={20} />
            {t.contact.linkedin}
          </a>
          
          <a 
            href="#" 
            className="contact-link disabled"
            title="Coming soon"
          >
            <Github size={20} />
            {t.contact.github}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;